<template>
  <v-card>
    <v-stepper v-model="e1" flat>
      <v-stepper-items>
        <v-stepper-content step="1" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4" flat id="1">
            <v-card-title class="education_title">
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
              <v-divider vertical class="hidden-md-and-up ml-2 mr-2 mx-2"></v-divider>
              <v-divider vertical class="hidden-sm-and-down ml-5 mr-5"></v-divider>
              <div class="red--text text--darken-2 education_title_notitext">방문객 안전교육</div>
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2" style="overflow:auto;height:200px;">
              모두에게 가치 있는 최고의 파트너, <strong class="red--text text--lighten-1">{{$store.state.CustomInfo.SiteNm}}</strong> 방문을 환영합니다. <br>
            </v-card-text>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="2" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4" min-height="520" flat id="2">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">개 요</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 pb-0">
              <strong class="deep-orange--text">목 적</strong><br>
              <span>
                {{ $store.state.CustomInfo.SiteNm }}에서 알아야 할 유의사항 및 위험요인에 대한 교육을 통해 아래의 목적을 달성하기 위함
              </span>
              <div class="mt-2 ml-4 mb-2 text_first_font d-flex">
                1.&nbsp;
                <div>사업장 출입 시 유의사항 안내를 통한 <strong class="red--text text--lighten-1">사고 예방</strong></div>
              </div>
              <div class="mt-2 ml-4 mb-2 text_first_font d-flex">
                2.&nbsp;
                <div>내방객 및 협력사 구성원에 대한 <strong class="red--text text--lighten-1">안전의식 고취</strong></div>
              </div>
              <div class="mt-2 ml-4 mb-2 text_first_font d-flex">
                3.&nbsp;
                <div>사내 규정 교육을 통한 <strong class="red--text text--lighten-1">안전작업 정착화</strong></div>
              </div>
              <!-- <p class="mt-2 ml-4 font-weight-bold body-1">1. 사업장 및 현장 출입 시 유의 사항 및 위험 요인 사전인지를 통한 <strong class="red--text text--lighten-1">사고 예방</strong></p>                
              <p class="ml-4 font-weight-bold body-1">2. 내방객 및 협력사 인력에 대한 안전의식 고취</p>                
              <p class="ml-4 font-weight-bold body-1">3. 사내 규정 교육을 통한 안전 작업 정착화</p>                 -->
              <!-- <div class="mb-2">{{$store.state.CustomInfo.SiteNm}} 사내 규정 및 주의사항 등의 안전교육을 통한</div>
              <p class="text-h6 font-weight-bold ml-4">1. 사업장 및 현장 출입 시 유의 사항 및 위험 요인 사전인지를 통한 사고 예방</p>
              <p class="text-h6 font-weight-bold ml-4">2. 내방객 및 협력사 인력에 대한 안전의식 고취</p>
              <p class="text-h6 font-weight-bold ml-4">3. 사내 규정 교육을 통한 안전 작업 정착화</p> -->
            </v-card-text>
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <strong class="deep-orange--text">대 상</strong><br>
              <div class="mt-2 ml-4 mb-2 text_first_font d-flex">
                <div>내방객 / 관계사 / 협력사 전체</div>
              </div>
            </v-card-text>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="3" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="32">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">01. SHE 방침</div>                
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2">                
              {{$store.state.CustomInfo.SiteNm}}는 경영활동의 모든 단계에서 인간과 환경의 보호를 최우선 가치로 추구하며, 구성원과 이해관계자가 신뢰하는 안전하고 행복한 일터를 만들기 위해 다음 사항을 적극 실천한다.
            </v-card-text>          
            <v-card class="ma-5 pa-5 education_content lineHeight2 ">
              <div class="d-flex">
                <strong>1.&nbsp;</strong>
                <div>
                  <strong>안전하고 건강한 사업장 조성</strong><br>
                  SHE 경영체계를 지속적으로 개선하여 구성원, 지역사회, 고객 등 모든 이해관계자가 신뢰할 수 있는 안전하고 건강한 사업장을 함께 만들어간다.
                </div>
              </div>
              <div class="d-flex">
                <strong>2.&nbsp;</strong>
                <div>
                  <strong>친환경 가치 추구</strong><br>
                  친환경적 설계, 자원의 효율적 사용, 화학물질의 철저한 관리를 통해 사업장과 지역사회의 환경을 보호하고, 선제적으로 온실가스를 감축함으로써 전 지구적 기후변화 위기에 적극적으로 대응한다.
                </div>
              </div>
              <div class="d-flex">
                <strong>3.&nbsp;</strong>
                <div>
                  <strong>준법 경영 및 투명한 정보공개</strong><br>
                  SHE 법규, 사규 및 이해관계자의 요구사항을 준수하고, 투명한 정보공개를 통해 이해관계자의 신뢰를 확보한다.
                </div>
              </div>
              <div class="d-flex">
                <strong>4.&nbsp;</strong>
                <div>
                  <strong>구성원 참여</strong><br>
                  모든 구성원은 인간과 환경 보호를 최우선 가치로 인식하고, 보다 안전하고 건강한 사업장을 만들기 위해 적극적으로 동참한다.
                </div>
              </div>
            </v-card>

            <!-- <v-card-text class="greeting_date text-center">
              {{sNowYear}} 년 {{sNowMounth}} 월 {{sNowDate}} 일
            </v-card-text>
            <v-card-text class="greeting_title text-center">
              {{$store.state.CustomInfo.SiteNm}} 대표이사 귀하
            </v-card-text>             -->
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="4" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4" min-height="520" flat id="4">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">02. Safety Golden Rules</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>

            <v-card-text class="education_content lineHeight2">
              SK에어플러스에서 반드시 지켜야 할 8대 Golden Rule 안전 방침입니다.<br>
              이를 미 준수 시 <strong class="red--text text--lighten-1">무관용 원칙(One Strike Out)</strong>이 적용됩니다.<br>
            </v-card-text>
            <v-divider></v-divider>

            
            <v-card-text class="education_content lineHeight2 text-center">
              <strong>Safety Golden Rules</strong><br>
            </v-card-text>
            

            <v-card-text class="education_content lineHeight2">
              <div class="d-flex align-start pledge_content">
                <div style="flex: 1; margin-top:0px;">
                  <div class="d-flex">
                    <div class="ml-0 mt-1 ">
                      <img src="../assets/SKMA_rules1.png" style="height:40px">
                    </div>
                    1.&nbsp;
                    <div>유해·위험물질 취급/작업 時 지정된 보호구 착용</div>
                  </div>
                  <div class="d-flex">
                    <div class="ml-0 mt-1 ">
                      <img src="../assets/SKMA_rules2.png" style="height:40px">
                    </div>
                    2.&nbsp;
                    <div>사고보고 기준 준수</div>
                  </div>
                  <div class="d-flex">
                    <div class="ml-0 mt-1 ">
                      <img src="../assets/SKMA_rules3.png" style="height:40px">
                    </div>
                    3.&nbsp;
                    <div>작업 時 작업허가서 승인 후 작업</div>
                  </div>
                  <div class="d-flex">
                    <div class="ml-0 mt-1 ">
                      <img src="../assets/SKMA_rules4.png" style="height:40px">
                    </div>
                    4.&nbsp;
                    <div>밀폐작업 時 산소농도/유해가스 측정</div>
                  </div>
                  <div class="d-flex">
                    <div class="ml-0 mt-1 ">
                      <img src="../assets/SKMA_rules5.png" style="height:40px">
                    </div>
                    5.&nbsp;
                    <div>고소지역 작업 時 추락 예방 조치 후 작업</div>
                  </div>
                  <div class="d-flex">
                    <div class="ml-0 mt-1 ">
                      <img src="../assets/SKMA_rules6.png" style="height:40px">
                    </div>
                    6.&nbsp;
                    <div>변경 관리 절차 준수</div>
                  </div>
                  <div class="d-flex">
                    <div class="ml-1 mt-1 ">
                      <img src="../assets/SKMA_rules7.png" style="height:30px">
                    </div>
                    7.&nbsp;
                    <div>지정된 장소 外 금연</div>
                  </div>
                  <div class="d-flex">
                    <div class="ml-1 mt-1 ">
                      <img src="../assets/SKMA_rules8.png" style="height:30px">
                    </div>
                    8.&nbsp;
                    <div>사내 운송수단 안전수칙 준수</div>
                  </div>
                </div>

                <div>
                  <table class="type10 text-center" style="width: 100%; margin-top:0px;">
                    <thead>
                      <tr>
                        <th scope="cols">S.G.R 항목</th>
                        <th scope="cols">세부 지침</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>유해·위험물질 취급/작업 時 지정된 보호구 착용</td>
                        <td> 
                          - 유해·위험물질의 취급 및 작업 시 규정된 <strong class="red--text text--lighten-1"> 안전보호구</strong> 및 안전장비를 <strong class="red--text text--lighten-1">착용</strong>하여야 한다. <br>*방독마스크, 내산복, 내산장갑, 내산장화, 방염복, Face Shield 등</td>
                      </tr>
                      <tr>
                        <td>사고보고 기준 준수</td>
                        <td>- 산업사고를 포함한 모든 사고 발생 시 <strong class="red--text text--lighten-1">즉시</strong> 보고한다.<br>(사고 은폐가 발생한 경우 1년 내 인지한 시점으로 적용한다.)</td>
                      </tr>
                      <tr>
                        <td>작업 時 작업허가서 승인 후 작업</td>
                        <td>
                          - 안전작업허가 절차에 따라 <strong class="red--text text--lighten-1">작업허가서 발행 승인</strong>을 받고 작업을 실시하여야 한다.<br>
                          - 최종 승인권자의 승인 없이 작업을 금지한다.<br>
                          - <strong class="red--text text--lighten-1">작업 전 위험성 평가</strong>를 반드시 실시하여야 한다.<br>
                          - 화기 작업의 경우 인화성 가스 농도를 측정해야 한다.<br>
                          - 유해화학물질이 있는 배관은 Drain / Purge 여부를 확인해야 한다.<br>
                        </td>
                      </tr>
                      <tr>
                        <td>밀폐작업 時 산소농도/유해가스 측정</td>
                        <td>
                          - 밀폐작업 時 반드시 <strong class="red--text text--lighten-1">산소 농도를 </strong>주기적으로 <strong class="red--text text--lighten-1">측정</strong>해야 한다.<br>
                          - 내부 보관된 물질이 있는 경우 유해가스를 측정해야 한다.<br>
                          - Valve 차단 확인, 맹판(Blind) 설치, 단관 분리 등의 조치를 통해 안전을 확보하여야 한다.<br>
                          - 허가서에 기재된 비상 대기자는 반드시 상주하여야 한다.<br>
                        </td>
                      </tr>
                      <tr>
                        <td>고소지역 작업 時 추락 예방 조치 후 작업</td>
                        <td>
                          - 고소작업 시 <strong class="red--text text--lighten-1">안전벨트 착용 </strong>및 체결해야 한다. (철골 등의 작업 시 2중 안전고리 사용)                          <br>
                          - 비계설치 후 작업 시에는 비계 승인표 승인 후 작업해야 한다.<br>
                        </td>
                      </tr>
                      <tr>
                        <td>변경관리 절차 준수</td>
                        <td>
                          - 변경사항 발생시 기술검토 또는 위험성평가를 실시하고 변경승인 후 작업을 실시해야 한다.<br>
                          - 가동 전 점검을 반드시 실시하고 승인 후에 가동한다. (비상변경의 경우에는 절차를 따른다.)<br>
                        </td>
                      </tr>
                      <tr>
                        <td>지정된 장소 外 금연</td>
                        <td>
                          - 공장 내 <strong class="red--text text--lighten-1">지정된 장소</strong> (흡연장)에서 흡연해야 한다.<br>
                          - 공장 출입 時 라이터는 휴대할 수 없다. (단, 작업용 라이터(작업 전용)는 제외한다.)<br>
                        </td>
                      </tr>
                      <tr>
                        <td>사내 운송수단 안전수칙 준수</td>
                        <td>
                          - 사내 모든 운송수단은 <strong class="red--text text--lighten-1">10km/h</strong> 속도를 준수해야 한다. (지게차, 크레인 등 10km/h)<br>
                          * 충전작업 장소의 운행 속도는 10km/h 준수<br>
                          * 입주사 및 고객사 내부 도로 통행 시 내부에서 규정하는 운행속도 준수<br>
                          - 운전 중 통화·문자·영상물 시청을 하여서는 안 된다.
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

            </v-card-text>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="5" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="7">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">02. Safety Golden Rules</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <div></div>
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              Safety Golden Rules를 지키지 않아 위반상황 발생 시 SK에어플러스 구성원을 포함한 모두 경고없이<br>
              <strong class="red--text text--lighten-1">즉시 Penalty가 적용</strong>되며 협력사의 경우 개인 출입 정지 및 업체 평가에 반영됩니다.<br>
            </v-card-text>

            <span class="text-center font-weight-bold d-block" style="font-size: 24px;">위반상황 발생 시</span>
            <div class="mt-2">
              <table class="type09 text-center">
                <thead>
                  <tr>
                    <th scope="cols">구 분</th>
                    <th scope="cols">1차 위반</th>
                    <th scope="cols">2차 위반</th>
                    <th scope="cols">3차 위반</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>구성원</td>
                    <td>위반자 경고(팀장)</td>
                    <td>위반자 경고(팀장)</td>
                    <td>인사 위원회</td>
                  </tr>
                  <tr>
                    <td>협력회사</td>
                    <td>대표 주관 안전교육</td>
                    <td>6개월 출입금지</td>
                    <td>영구 출입금지</td>
                  </tr>
                </tbody>
              </table>
              </div>

            <span class="text-center font-weight-bold d-block" style="font-size: 24px; margin-top:60px;">위반 적발 시</span>

            <div class="mt-2">
              <v-card-text class="education_content lineHeight2 grey--text text--darken-1">

              <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">
                <div class="circle_Box2 ma-2 text-center font-weight-black"><strong class="text-h4 red--text font-weight-black">1</strong><br>즉시 작업중지 & 안전교육</div>
                <div class="circle_Box2_no d-flex"><v-icon x-large color="grey lighten-2">mdi-arrow-right-thick</v-icon></div>
                <div class="circle_Box2 ma-2 text-center font-weight-black"><strong class="text-h4 red--text font-weight-black">2</strong><br>SHE팀 보고 및 승인</div>
              </div>
            </v-card-text>
            </div>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="6" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="5">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">03. 안전보호구 착용 기준</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>

            <v-row class="ma-0">
              <v-col cols="12" md="6" sm="12">
                <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                  <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                    사업장 공정 內 모든 장소에서는 <strong class="red--text text--lighten-1">안전모</strong>와 <strong class="red--text text--lighten-1">안전화</strong> 착용을 원칙으로 합니다.<br>
                    작업 종류에 따라 지정된 안전보호구를 착용 후 작업합니다.<br>
                  </v-card-text>
                  <div class="mt-2 ml-4 mb-2 text_first_font">
                    <p class="iron_center_contents">
                      <img src="../assets/safe_tool_0.jpg" style="height:200px; border-radius: 10px;">
                      <img src="../assets/safe_tool_1.jpg" class= "ml-12" style="height:200px; border-radius: 10px;">
                    </p>
                  </div>
                </v-card-text>
                <v-card-text class="education_content lineHeight2 mt-12">
                  ※  안전보호구 미착용 시 <strong class="red--text text--lighten-1">무관용 원칙(One Strike Out)이 적용됩니다.</strong>
                </v-card-text>
              </v-col>
              
            </v-row>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="7" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="5">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">04. 안전∙보건 표지</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>

            <v-row class="ma-0">
              <v-col cols="12" md="12" sm="12">
                <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                  <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                    작업장 또는 건물 내부 출입 시에는 <strong class="red--text text--lighten-1">금지</strong>/ <strong class="amber--text">경고</strong>/ <strong class="blue--text">지시</strong>/ <strong class="green--text">안내</strong>/
                    안전∙보건표지를 확인하고, 해당하는 행동을 반드시 준수하여야 합니다.<br>
                  </v-card-text>
                  <v-card-text class="education_content lineHeight2" style="font-size:20px;">
                    작업자가 <strong class="red--text text--lighten-1">판단이나 행동의 잘못</strong>을 일으키기 쉬운 장소 또는 작업자가 
                    <strong class="red--text text--lighten-1">실수로 인해 중대한 재해</strong>를 일으킬 위험이 있는 장소에는 
                    안전보건표지를 게시함으로써 <strong class="red--text text--lighten-1">근로자의 안전보건 확보</strong>를 위해 표시하는 표지
                    <br>
                  </v-card-text>
                  
                  <v-row class="mt-2 ml-4 mb-2 text_first_font d-flex justify-center">
                    <v-col cols="12" md="3" sm="12">
                      <v-card class="mt-4 mt-md-0 d-flex flex-column fill-height">
                        <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                          <strong class="red--text text--lighten-1">금 지(특정 행동을 금지)</strong>
                        </v-card-text>
                        <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6 mt-12 ">
                          <div class="ma-4 text-center font-weight-black ">
                            <div class="iron_center_contents"><img src="../assets/safe_01.png" style="height:150px; border-radius: 10px;"></div>출입 금지
                          </div> 
                          <div class="ma-4 text-center font-weight-black">
                            <div class="iron_center_contents"><img src="../assets/safe_07.png" style="height:150px; border-radius: 10px;"></div>화기 금지
                          </div>
                        </div>
                      </v-card>
                    </v-col>

                    <v-col cols="12" md="3" sm="12">
                      <v-card class="mt-4 mt-md-0 d-flex flex-column fill-height">
                        <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                          <strong class="amber--text">경 고(위험한 상태 및 장소에 대한 경고)</strong>
                        </v-card-text>
                        <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">
                          <div class="ma-4 text-center font-weight-black">
                            <div class="iron_center_contents"><img src="../assets/warn_08.png" style="height:150px; border-radius: 10px;"></div>위험장소 경고
                          </div> 
                          <div class="ma-4 text-center font-weight-black">
                            <div class="iron_center_contents mt-2"><img src="../assets/warn_12.png" style="height:130px; border-radius: 10px;"></div>
                            <div class="mt-3">저온 경고</div>
                          </div>
                        </div>
                      </v-card>
                    </v-col>

                    <v-col cols="12" md="3" sm="12">
                      <v-card class="mt-4 mt-md-0 d-flex flex-column fill-height">
                        <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                          <strong class="blue--text">지 시 (보호구 착용을 지시)</strong>
                        </v-card-text>
                        <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6 mt-12">
                          <div class="ma-4 text-center font-weight-black">
                            <div class="iron_center_contents"><img src="../assets/guide_dir_05.png" style="height:150px; border-radius: 10px;"></div>안전모 착용
                          </div> 
                          <div class="ma-4 text-center font-weight-black">
                            <div class="iron_center_contents"><img src="../assets/guide_dir_07.png" style="height:150px; border-radius: 10px;"></div>안전화 착용
                          </div>
                        </div>
                      </v-card>
                    </v-col>

                    <v-col cols="12" md="3" sm="12">
                      <v-card class="mt-4 mt-md-0 d-flex flex-column fill-height">
                        <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                          <strong class="green--text">안 내(정보전달 목적 안내대상을 지시)</strong>
                        </v-card-text>
                        <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6 mt-12">
                          <div class="ma-4 text-center font-weight-black">
                            <div class="iron_center_contents"><img src="../assets/guide_04.png" style="height:150px; border-radius: 10px;"></div>세안장치
                          </div> 
                          <div class="ma-4 text-center font-weight-black">
                            <div class="iron_center_contents"><img src="../assets/guide_03.png" style="height:150px; border-radius: 10px;"></div>들것
                          </div>
                        </div>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="8" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="6">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">05. 사고공유 기준 </div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>

            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              아래와 같은 사고 발생시 <strong class="red--text text--lighten-1">즉시 </strong>공유 하여야 함. 
            </v-card-text>


            <v-row>
              <v-col cols="12" md="7" sm="12">
                <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                  <div class="d-flex">
                    1.&nbsp;
                    <div>공정 및 환경 사고</div>
                  </div>
                  <div class="d-flex ml-5">
                    <v-icon>mdi-check</v-icon>
                    <div class="ml-2">화재 및 폭발 사고 / 설비 파손 사고 / 환경 누출 사고</div>
                  </div>
                  <div class="d-flex ml-5">
                    <v-icon>mdi-check</v-icon>
                    <div class="ml-2">작업 중 자재, 공구 등을 떨어뜨려 공정설비(기계, 배관, 계측기 등)에 영향을 준 경우</div>
                  </div>
                  <div class="d-flex ml-5">
                    <v-icon>mdi-check</v-icon>
                    <div class="ml-2">수질/대기 오염물질의 유출, 유해화학물질의 토양 또는 하천으로의 유입 등이 발생한 경우</div>
                  </div>
                  <div class="d-flex ml-5">
                    <div class="ml-8">ex : 오일이 토양으로 유출된 경우, 작업 도중 실수로 설비가 파손된 경우</div>
                  </div>
                  <div class="d-flex">
                    2.&nbsp;
                    <div>안전사고(상해사고)</div>
                  </div>
                  <div class="d-flex ml-5">
                    <v-icon>mdi-check</v-icon>
                    <div class="ml-2">병원에 가지 않고 자체적으로 치료가 가능한 상해사고</div>
                  </div>
                  <div class="d-flex ml-5">
                    <div class="ml-8">ex : 오일이 토양으로 유출된 경우, 작업 도중 실수로 설비가 파손된 경우</div>
                  </div>
                  <div class="d-flex ml-5">
                    <v-icon>mdi-check</v-icon>
                    <div class="ml-2">병원에서의 의료 처치</div>
                  </div>
                  <div class="d-flex ml-5">
                    <div class="ml-8">ex : 주사를 맞거나 처방전을 받은 경우/입원 또는 자택 등에서 요양 하는 경우, 사망사고 등 대외적으로 물의를 일으키거나 회사경영에 손실을 입힌 사고</div>
                  </div>
                </v-card-text>
              </v-col>
            </v-row>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="9" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="6">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">05. 사고공유 기준 </div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>

            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">
                <div class="circle_Box3 ma-2 text-center font-weight-black white--text"><strong class="text-h4 font-weight-black">1</strong><br>사고발생</div>
                <div class="circle_Box2_no d-flex"><v-icon x-large color="grey lighten-2">mdi-arrow-right-thick</v-icon></div>
                <div class="circle_Box2 ma-2 text-center font-weight-black"><strong class="text-h4 red--text font-weight-black">2</strong><br>최초 목격자</div>
                <div class="circle_Box2_no d-flex"><v-icon x-large color="grey lighten-2">mdi-arrow-right-thick</v-icon></div>
                <div class="circle_Box3 ma-2 text-center font-weight-black yellow--text"><strong class="text-h4 font-weight-black">3</strong><br>SK에어플러스(조정실)</div>
              </div>
            </v-card-text>
            <strong class="deep-orange--text font-weight-black ml-6">사고 등 비상상황 발생 시 즉시 SK에어플러스로 사고 공유</strong>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="10" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="7">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">06. 차량 안전 기준</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              SK에어플러스 內 차량 운행 시에는 <strong class="red--text text--lighten-1">5대 중요사항</strong>을 실천하여 차량 안전사고를 예방합니다. 
            </v-card-text>

            <v-row class="mt-2 ml-4 mb-2 text_first_font d-flex justify-center">
              <v-col cols="12" md="12" sm="12">
                <v-card class="d-flex flex-column fill-height">
                  <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                    <div style="text-align: center;">
                      <strong>규정 속도 준수</strong>
                    </div>
                  </v-card-text>
                  <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">
                    <div class="ma-4 text-center font-weight-black">
                      <div class="iron_center_contents"><img src="../assets/SKMA_speedlimit.jpg" style="height:150px; border-radius: 10px;"></div>사내 규정속도 10km/h 준수<br>(건설기계,운송차량 10km)
                    </div> 
                  </div>
                </v-card>
              </v-col>


              <v-col cols="12" md="12" sm="12">
                <v-card class="d-flex flex-column fill-height">
                  <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                    <div style="text-align: center;">
                      <strong>휴대폰 사용금지</strong>
                    </div>
                  </v-card-text>
                  <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">
                    <div class="ma-4 text-center font-weight-black">
                      <div class="iron_center_contents"><img src="../assets/SKMA_noCellphone.png" style="height:150px; border-radius: 10px;"></div>운전 중 스마트폰 사용 금지
                    </div>
                  </div>
                </v-card>
              </v-col>



              <v-col cols="12" md="12" sm="12">
                <v-card class="d-flex flex-column fill-height">
                  <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                    <div style="text-align: center;">
                      <strong>주∙정차 위반금지</strong>
                    </div>
                  </v-card-text>
                  <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">
                    <div class="ma-4 text-center font-weight-black">
                      <div class="iron_center_contents"><img src="../assets/SKMA_noCar.png" style="height:150px; border-radius: 10px;"></div>주∙정차 구역 외 주차금지

                    </div>
                  </div>
                </v-card>
              </v-col>



              <v-col cols="12" md="12" sm="12">
                <v-card class="d-flex flex-column fill-height">
                  <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                    <div style="text-align: center;">
                      <strong>고임목 설치</strong>
                    </div>
                  </v-card-text>
                  <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">
                    <div class="ma-4 text-center font-weight-black">
                      <div class="iron_center_contents"><img src="../assets/SKMA_rubber.png" style="height:150px; border-radius: 10px;"></div>주∙정차 시 고임목 설치
                    </div> 
                  </div>
                </v-card>
              </v-col>



              <v-col cols="12" md="12" sm="12">
                <v-card class="d-flex flex-column fill-height">
                  <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                    <div style="text-align: center;">
                      <strong>방향 지시등 점등</strong>
                    </div>
                  </v-card-text>
                  <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">
                    <div class="ma-4 text-center font-weight-black">
                      <div class="iron_center_contents"><img src="../assets/SKMA_light.png" style="height:150px; border-radius: 10px;"></div>사내 이동 중 방향 지시등 점등
                    </div>
                  </div>
                </v-card>
              </v-col>
              <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">
                <div class="ma-4 mt-12 text-center font-weight-black">
                  <div class="iron_center_contents"><img src="../assets/SKMA_car.png" style="height:150px; border-radius: 10px;"></div>
                </div>
              </div> 
            </v-row>

          </v-card>
        </v-stepper-content>

        <v-stepper-content step="11" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="7">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">07. 흡연 및 화재예방 기준</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              흡연은 지정된 장소에서만 가능합니다. 미 준수 시 <strong class="red--text text--lighten-1">무관용 원칙(One Strike Out)</strong>이 적용됩니다.
            </v-card-text>
            <v-row class="ma-0">
              <v-col cols="12" md="12" sm="12">
                <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                  <div class="mt-2 ml-4 mb-2 text_first_font d-flex justify-center">
                    <v-card>
                      <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                        <strong class="deep-orange--text">흡연 및 화재예방 안전수칙</strong><br>
                      </v-card-text>
                      <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">
                        <div class="ma-4 text-center font-weight-black">
                          <div class="iron_center_contents">
                            <img src="../assets/SKMA_smoke1.png" style="height:150px; border-radius: 10px;">
                          </div>사내 지정된 장소에서만 흡연
                        </div> 
                        <div class="ma-4 text-center font-weight-black">
                          <div class="iron_center_contents">
                            <img src="../assets/SKMA_smoke2.png" style="height:150px; border-radius: 10px;">
                          </div>담배꽁초 무단투기 금지
                        </div> 
                        <div class="ma-4 text-center font-weight-black">
                          <div class="iron_center_contents">
                            <img src="../assets/SKMA_smoke3.png" style="height:150px; border-radius: 10px;">
                          </div>흡연 후 재떨이에 담뱃불 소화
                        </div> 
                        <div class="ma-4 text-center font-weight-black">
                          <div class="iron_center_contents">
                            <img src="../assets/SKMA_smoke4.png" style="height:150px; border-radius: 10px;">
                          </div>담배꽁초 불씨 확인
                        </div> 
                      </div>
                    </v-card>
                  </div>
                </v-card-text>
                
              </v-col>
            </v-row>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="12" class="education_make_scroll pa-0">
          <v-row>
            <v-col cols="12" md="12">
              <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="22">
                <v-card-title class="education_title">
                  <div class="red--text text--darken-2 education_title_text">08. 비상 대응 절차</div>
                  <v-spacer></v-spacer>
                  <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
                </v-card-title>
                <v-divider class="mb-2"></v-divider>
                <div class="pledge_content">
                  <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                    누출, 화재, 폭발 등 비상상황 발생 시 <strong class="red--text text--lighten-1">신속∙정확한 신고 </strong>및 주변 전파를 실시하고 
                    <strong class="red--text text--lighten-1">대피</strong>를 통해 인명피해를 최소화 합니다.
                  </v-card-text>

                  <div class="d-flex" style="justify-content: space-between; align-items: flex-start;">
                    <!-- 왼쪽 텍스트 영역 -->
                    <div style="flex: 1;">
                      <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                          
                        <div class="flex-wrap d-flex flex-column justify-center mt-0 mb-0 text-h6">
                          <div class="d-flex align-center">
                            <div class="square_Box ma-2 text-center font-weight-black">
                              <strong class="text-h4 yellow--text font-weight-black">1</strong><br>
                              <span style="color: black;">비상상황</span>
                            </div>
                          </div>
                          <div class="circle_Box2_no d-flex" style="margin: -60px 65px;">
                            <v-icon x-large color="grey lighten-2">mdi-arrow-down-thick</v-icon>
                          </div>
                          <div class="d-flex align-center">
                            <div class="square_Box ma-2 text-center font-weight-black">
                              <strong class="text-h4 yellow--text font-weight-black">2</strong><br>
                              <span style="color: black;">신 고</span><br>
                            </div>
                          </div>
                          <div class="mt-2 ml-3">
                            <span style="color: black;">※ 사고 장소</span><br>
                            <span style="color: black;">※ 사고 유형(규모)</span><br>
                            <span style="color: black;">※ 부상자 유무</span><br>
                          </div>
                          <div class="square_Box_no d-flex" style="margin: -60px 65px;">
                            <v-icon x-large color="grey lighten-2">mdi-arrow-down-thick</v-icon>
                          </div>
                          <div class="d-flex align-center">
                            <div class="square_Box ma-2 text-center font-weight-black">
                              <strong class="text-h4 yellow--text font-weight-black">3</strong><br>
                              <span style="color: black;">비상방송,경보</span><br>
                            </div>
                          </div>
                          <div class="square_Box_no d-flex" style="margin: -60px 65px;">
                            <v-icon x-large color="grey lighten-2">mdi-arrow-down-thick</v-icon>
                          </div>
                          <div class="d-flex align-center">
                            <div class="square_Box ma-2 text-center font-weight-black">
                              <div class="d-flex align-items-center justify-center mr-15">
                                <img src="../assets/SKMA_E.png" style="height:50px; border-radius: 10px; margin-right: 8px;">
                                <strong class="text-h4 yellow--text font-weight-black">4</strong>
                              </div>
                              <br>
                              <div style="margin-top: -35px;">
                                <span style="color: black;">지정장소 대피</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </v-card-text>
                    </div>
              
                    <!-- 오른쪽 -->
                    <div style="flex: 3; text-align: right; margin-top: 10px; margin-right: 20px;">
                      <v-card>
                        <v-card-text class="text_first_font lineHeight2">
                          <div style="text-align: start;">
                            <strong class="text-h5 deep-orange--text font-weight-black">비상 상황</strong> 
                          </div>
                          <v-row class="ma-0 mb-2">
                            <v-col cols="12" md="12" sd="12">
                              <div class="d-flex"><strong class="deep-orange--text caption mr-2">●</strong>조업상 비상상황</div>
                            </v-col>
                            <div class="ml-9" style="text-align: start;">
                              - 가스누출 : 제조∙취급 물질의 누출로 알람 발생 또는 가스냄새 발생 시<br>
                              - 화재∙폭발 : 가연성, 인화성 가스 누출로 인한 연기 및 화재 발생<br>
                              - 인체상해 : 추락, 협착, 질식 등의 사고<br>
                              - 인근사 비상상황 : 인근사 또는 인근지역에서 발생한 사고로 공정에 영향을 미치는 경우<br> 
                              - 환경오염사고 : 공정상 발생 오염물질이 외부로 유출되어 환경오염사고를 발생한 경우<br>
                            </div>

                            <v-col cols="12" md="12" sd="12">
                              <div class="d-flex"><strong class="deep-orange--text caption mr-2">●</strong>자연재해에 따른 비상상황</div>
                            </v-col>
                            <div class="ml-9" style="text-align: start;">
                              - 태풍, 낙뢰, 홍수, 지진 등 천재지변에 의한 재해 발생으로 공정에 영향을 미치는 경우<br>
                            </div>
                          </v-row>
                        </v-card-text> 
                      </v-card>
                    </div>
                  </div>
                </div>
              </v-card>
            </v-col>
          </v-row>
        </v-stepper-content>

        <v-stepper-content step="13" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="7">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">09. 비상 집결지</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              작업 전 <strong class="red--text text--lighten-1">대피 경로와 비상구를 확인</strong>하고, 건물 밖으로 대피시에는 <strong class="red--text text--lighten-1">비상구(계단)을 이용</strong>
              하여 비상 집결지로 대피하여 주시기 바랍니다. 
            </v-card-text>
            
            <v-row class="ma-0">
              <v-col cols="12" md="12" sm="12">
                <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                  <div class="mt-2 ml-4 mb-2 text_first_font">
                    <v-row class="ma-0" no-gutters>
                      <v-col cols="12" md="3" sm="12" class="pa-1">
                        <v-card class="d-flex flex-column fill-height">
                          <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                            <div style="text-align: center;">
                              <strong>대피 안내도</strong>
                            </div>
                          </v-card-text>
                          <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">
                            <div class="ma-4 text-center font-weight-black">
                              <div class="iron_center_contents">
                                <img src="../assets/SKMA_emergency1.jpg" style="height:150px; border-radius: 10px;">
                              </div>
                              <span style="font-size: 13px;">※ 각 공장별 표지 양식 상이</span>
                            </div> 
                          </div>
                        </v-card>
                      </v-col>

                      <v-col cols="12" md="3" sm="12" class="pa-1">
                        <v-card class="d-flex flex-column fill-height">
                          <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                            <div style="text-align: center;">
                              <strong>비상 유도등</strong>
                            </div>
                          </v-card-text>
                          <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">
                            <div class="ma-4 text-center font-weight-black">
                              <div class="iron_center_contents">
                                <img src="../assets/SKMA_emergency2.jpg" style="height:150px; border-radius: 10px;">
                              </div>
                            </div>
                          </div>
                        </v-card>
                      </v-col>

                      <v-col cols="12" md="3" sm="12" class="pa-1">
                        <v-card class="d-flex flex-column fill-height">
                          <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                            <div style="text-align: center;">
                              <strong>대피 안내 표지</strong>
                            </div>
                          </v-card-text>
                          <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">
                            <div class="ma-4 text-center font-weight-black">
                              <div class="iron_center_contents">
                                <img src="../assets/SKMA_emergency3.jpg" style="height:150px; border-radius: 10px;">
                              </div>
                            </div>
                          </div>
                        </v-card>
                      </v-col>

                      <v-col cols="12" md="3" sm="12" class="pa-1">
                        <v-card class="d-flex flex-column fill-height">
                          <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                            <div style="text-align: center;">
                              <strong>대피 안내 표지</strong>
                            </div>
                          </v-card-text>
                          <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">
                            <div class="ma-4 text-center font-weight-black">
                              <div class="iron_center_contents">
                                <img src="../assets/SKMA_emergency4.jpg" style="height:150px; border-radius: 10px;">
                              </div>
                            </div>
                          </div>
                        </v-card>
                      </v-col>
                    </v-row>
                  </div>
                </v-card-text>

                <v-card>
                  <v-row class="ma-0 mb-2">
                    <v-col cols="12" md="12" sd="12">
                      <div class="d-flex"><strong class="deep-orange--text caption mr-2">●</strong>대피 시 행동요령</div>
                    </v-col>
                    <div class="ml-9" style="text-align: start; line-height: 2;">
                      1. 본인의 안전 확보 불가 판단 시, 집결지로 대피 한다.<br>
                      2. 안내방송(사이렌)을 경청하고, 비상 집결지로 대피 한다.<br>
                      <strong class="red--text text--lighten-1">3. 대피 후에는 관리자에게 대피현황을 공유 한다.</strong><br>
                      4. 대피 완료 후 착용한 의류나 신발은 세척 또는 폐기한다. (독성가스 누출 시)<br> 
                    </div>
                  </v-row>
                </v-card>
              </v-col>
            </v-row>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="14" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="31">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">10. 작업 중지권</div>                
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            
            <div class="pledge_content">
              <v-row>
                <v-col cols="12" md="6" sd="6">
                  <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                    SK에어플러스는 안전이 확보되지 않은 <strong class="red--text text--lighten-1">작업은 지시하지 않으며</strong>, 지시하더라고 이를 <strong class="red--text text--lighten-1">거부할 권리</strong>
                    가 있으며 이로 인한 <strong class="red--text text--lighten-1">불이익은 없습니다.</strong>
                  </v-card-text>
                  <div class="d-flex" style="justify-content: space-between; align-items: flex-start;">
                    <!-- 왼쪽 -->
                    <div>
                      <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                        <img src="../assets/SKMA_rights.jpg" style="width: 100%; max-width: 500px; border-radius: 20px;">
                      </v-card-text>
                  
                      <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                        <div class="box_4 education_content pa-2 ml-0" style="font-size: 20px; font-weight: bold; color: LightGoldenRodYellow;">
                          <div style="width: 100%; max-width: 858px; border-radius: 20px;">
                            <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                              <span><strong class="text-h4 font-weight-bold">작업 중지권</strong></span><br>
                              안전하지 않은 근로조건이나 행동이 존재 할 경우, <strong class="red--text text--lighten-1">근로자는 작업을 중단할 권리를 </strong>
                              가지고 있습니다.
                            </v-card-text>
                          </div>
                        </div>
                      </v-card-text>
                    </div>
                  </div>
                </v-col>
                <!-- 오른쪽 -->
                <v-col cols="12" md="6" sd="6">
                  <div style="margin-top: 13%; margin-right: 10%;">
                    <v-card>
                      <v-card-text class="text_first_font lineHeight2 mt-3">
                        <div style="text-align: start;">
                          <strong class="text-h5 deep-orange--text font-weight-black">비상 상황</strong> 
                        </div>
                        <v-row class="ma-0 mb-2">
                          <v-col cols="12" md="12" sd="12">
                            <div class="d-flex"><strong class="deep-orange--text caption mr-2 ">●</strong> 중지권 행사가 필요한 경우</div>
                          </v-col>
                          <div class="ml-9" style="text-align: start;">
                            1. 중대재해 발생 시<br>
                            2. 급박한 위험상황(화재, 폭발, 누출 등) 발생 시<br>
                            3. 현장 점검 중 위험상황 발견 시<br>
                          </div>

                          <v-col cols="12" md="12" sd="12">
                            <div class="d-flex"><strong class="deep-orange--text caption mr-2">●</strong>작업 중지 후 행동요령</div>
                          </v-col>
                          <div class="ml-9" style="text-align: start;">
                            1. 위험요인 확인 요청<br>
                            2. 위험요인 개선 조치 및 SKAP 관리자 확인<br>
                            3. 작업 재개<br>
                          </div>
                        </v-row>
                      </v-card-text> 
                    </v-card>
                    <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                      <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">
                        <div class="circle_Box2 ma-2 text-center font-weight-black"><strong class="text-h4 red--text font-weight-black">1</strong><br>위험 확인 시<br><strong class="red--text text--lighten-1">작업중지</strong></div>
                        <div class="circle_Box2_no d-flex"><v-icon x-large color="grey lighten-2">mdi-arrow-right-thick</v-icon></div>
                        <div class="circle_Box2 ma-2 text-center font-weight-black"><strong class="text-h4 red--text font-weight-black">2</strong><br>현장 확인<br>및 개선<br></div>
                        <div class="circle_Box2_no d-flex"><v-icon x-large color="grey lighten-2">mdi-arrow-right-thick</v-icon></div>
                        <div class="circle_Box2 ma-2 text-center font-weight-black"><strong class="text-h4 red--text font-weight-black">3</strong><br>작 업<br>재 개<br></div>
                      </div>
                    </v-card-text>
                  </div>
                </v-col>
              </v-row>    
            </div>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="15" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" min-height="520" flat id="7">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">11. 종사자 의견 청취</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>

            <div class="pledge_content">
              <v-row>
                <v-col cols="12" md="6" sd="6">
                  <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                    SK에어플러스는 안전하고 쾌적한 작업환경을 확보하기 위하여 SHE 소리함을 운영함으로써, 종사자 분들의 의견을 듣고자 합니다.
                  </v-card-text>
                  <div class="d-flex" style="justify-content: space-between; align-items: flex-start;">
                    <!-- 왼쪽 -->
                    <div>
                      <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                        <img src="../assets/SKMA_SHE.jpg" style="width: 100%; max-width: 500px; border-radius: 20px;"><br>
                        <div style="margin-left:25%;">SHE 소리함 비치 사진</div>
                      </v-card-text>
                    </div>
                  </div>
                </v-col>
                <!-- 오른쪽 -->
                <v-col cols="12" md="6" sd="6">
                  <div style="margin-top: 15%; margin-right: 10%;">
                    <v-card>
                      
                    </v-card>
                    <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                  <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">
                    <div class="circle_Box2 ma-2 text-center font-weight-black"><strong class="text-h4 red--text font-weight-black">1</strong><br>SHE 소리<br>카드 작성<br><strong class="red--text text--lighten-1">(익명)</strong></div>
                    <div class="circle_Box2_no d-flex"><v-icon x-large color="grey lighten-2">mdi-arrow-right-thick</v-icon></div>
                    <div class="circle_Box2 ma-2 text-center font-weight-black"><strong class="text-h4 red--text font-weight-black">2</strong><br>SHE 소리<br>건의<br></div>
                    <div class="circle_Box2_no d-flex"><v-icon x-large color="grey lighten-2">mdi-arrow-right-thick</v-icon></div>
                    <div class="circle_Box2 ma-2 text-center font-weight-black"><strong class="text-h4 red--text font-weight-black">3</strong><br>SHE팀<br>확인,검토<br>(1회/월)<br></div>
                  </div>
                </v-card-text>
                  </div>
                </v-col>
              </v-row>    
            </div>

            <!-- <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
              SK에어플러스는 안전하고 쾌적한 작업환경을 확보하기 위하여 SHE 소리함을 운영함으로써, 종사자 분들의 의견을 듣고자 합니다.
            </v-card-text>
            <div class="d-flex" style="justify-content: space-between; align-items: flex-start;">

              <div style="flex: 1; margin-top:-5px;" >
                <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                  <img src="../assets/SKMA_SHE.jpg" style="width: 100%; max-width: 500px; border-radius: 20px;" /><br>
                  <div style="margin-left:135px;">SHE 소리함 비치 사진</div>
                </v-card-text>
              </div>
        

              <div style="flex: 2; text-align: right; margin-top: 10px; margin-right: 20px;">
                <v-card-text class="education_content lineHeight2 grey--text text--darken-1">
                  <div class="flex-wrap d-flex justify-center mt-0 mb-0 text-h6">
                    <div class="circle_Box2 ma-2 text-center font-weight-black"><strong class="text-h4 red--text font-weight-black">1</strong><br>SHE 소리<br>카드 작성<br><strong class="red--text text--lighten-1">(익명)</strong></div>
                    <div class="circle_Box2_no d-flex" ><v-icon x-large color="grey lighten-2">mdi-arrow-right-thick</v-icon></div>
                    <div class="circle_Box2 ma-2 text-center font-weight-black"><strong class="text-h4 red--text font-weight-black">2</strong><br>SHE 소리<br>건의<br></div>
                    <div class="circle_Box2_no d-flex"><v-icon x-large color="grey lighten-2">mdi-arrow-right-thick</v-icon></div>
                    <div class="circle_Box2 ma-2 text-center font-weight-black"><strong class="text-h4 red--text font-weight-black">3</strong><br>SHE팀<br>확인,검토<br>(1회/월)<br></div>
                  </div>
                </v-card-text>
              </div>
            </div> -->
          </v-card>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>

    <v-card-actions class="pa-4">
      <v-spacer></v-spacer>
      <v-btn v-show="e1 == 1" @click="$emit('CloseEdu')" text width="100"><v-icon>mdi-close</v-icon>취소</v-btn>
      <v-btn v-show="e1 != 1" text width="100" @click="PreviewPage()"><v-icon>mdi-chevron-left</v-icon>뒤로</v-btn>
      <v-btn v-show="e1 != 15" width="100" @click="NextPage()" dark><v-icon>mdi-chevron-right</v-icon>계속</v-btn>
      <v-btn v-show="e1 == 15" width="100" @click="$emit('CloseSafety')" dark><v-icon>mdi-chevron-right</v-icon>완료</v-btn>
    </v-card-actions>
  </v-card>    
</template>

<script>
import { mapState } from "vuex";

export default {
  components: {
  },
  data: () => ({
    e1: 1,
    ChangableHeight : "",
  }),

  props: {
    oCustomInfo: {
      type: Object,
      default () {
        return {}
      },
    },
  },

  computed: {
    ...mapState(["sNowYear","sNowMounth","sNowDate"]),
  },

  mounted() {
    this.$nextTick(() => {
  try {
    const element = document.getElementById("1");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  } catch (e) {
    // 오류 발생 시에도 콘솔에 아무것도 출력 안 하고 조용히 무시
  }
});

  },

  methods: {
    onResize(){
      if (window.innerWidth > 1350) {
        this.ChangableHeight = "calc(90vh - 225px)"
      } else if (window.innerWidth > 950 && window.innerWidth <= 1350) {
        this.ChangableHeight = "calc(90vh - 250px)"
      } else {
        this.ChangableHeight = String(document.getElementById('safe_4_rules_content').clientHeight) + "px"
      }
    },

    PreviewPage(){
      this.e1 -= 1
      this.$nextTick(() => {
        var element =  document.getElementById(this.e1);
        element.scrollIntoView({behavior : "smooth"})
      })
    },

    NextPage(){
      this.e1 += 1
      this.$nextTick(() => {
        var element =  document.getElementById(this.e1);
        element.scrollIntoView({behavior : "smooth"})
      })

      
    },
  }
};
</script>

<style scoped lang="scss">
  @import "../publishing/visit.scss";

  .box_2{
    width : inherit;    
    border-radius: 20px;    
    color: #FFEB3B;
    background-color: #F44336;
    text-align: center;    
  }
  .box_3{
    width : 350px;    
    border-radius: 10px;    
    color: #FFFFFF;
    background-color: #fc922f;
    text-align: center;    
  }
  .box_4{
    width : 500px;    
    border-radius: 10px;    
    color: #FFFFFF;
    background-color: #fc922f;
    text-align: center;    
  }
  .box_outlined{
    width : 300px;
    height : 200px;
    border-radius: 10px;    
    outline: solid;
    outline-color: #AAAAAA;
    outline-width: 1px;
    background-color: #f0f0f0;
    text-align: center;    
  }
  .circle_Box{    
    width : 32px;
    height : 32px;
    border-radius: 100px;    
    color : white;
    background-color: #000088;
    text-align: center;    
  }
  .circle_Box2{
    width : 170px;
    height : 170px;
    border-radius: 100px;        
    background-color: #EEEEEE;
    padding-top: 20px;
    text-align: center;    
  }
  .square_Box{
    width : 160px;
    height : 100px;
    border-radius: 10px;        
    background-color: #eb854a;
    padding-top: 10px;
    text-align: center;    
  }

  .square_Box2{
    width : 250px;
    height : 120px;
    border-radius: 10px;        
    background-color: #EEEEEE;
    padding-top: 10px;
    text-align: center;    
  }

  .circle_Box4{
    width : 190px;
    height : 190px;
    border-radius: 100px;        
    background-color: #FFFFFF;
    padding-top: 20px;
    text-align: center;    
    outline: solid;
    outline-color: #eeeeee;
    outline-width: 3px;
    box-shadow: 0px 0px 10px 10px #f3f3f3; 
  }
  .circle_Box4_longtext {
    max-width : 190px;
    border-radius: 100px;        
    background-color: #FFFFFF;
    padding-top: 20px;
    text-align: center;    
    outline: solid;
    outline-color: #eeeeee;
    outline-width: 3px;
    box-shadow: 0px 0px 10px 10px #f3f3f3;
  }
  .circle_Box2_no{
    width : 50px;
    height : 160px;                    
    vertical-align: center;
    text-align: center;    
  }
  .square_Box_no{
    width : 50px;
    height : 160px;                    
    vertical-align: center;
    text-align: center;    
  }
  .square_Box2_no{
    width : 50px;
    height : 160px;                    
    vertical-align: center;
    text-align: center;    
  }
  .circle_Box3{
    width : 160px;
    height : 160px;
    border-radius: 100px;        
    background-color: #F44336;
    padding-top: 20px;
    text-align: center;    
  }
  .lineHeight2{
    line-height: 180%
  }
  .sec_box{
    margin: auto;        
    text-align: center;
    box-shadow: 0px 0px 1px 1px #f3f3f3; 
  }

  table.type09 {
    border-collapse: collapse;
    text-align: left;
    line-height: 1.5;
    width : 100%;
  }
  table.type09 thead th {
    padding: 10px;
    font-weight: bold;
    vertical-align: center;
    /* color: #369; */
    border-bottom: 2px solid rgb(141, 141, 141);
  }
  table.type09 tbody th {
    width: 150px;
    padding: 10px;
    font-weight: bold;
    vertical-align: top;
    border-bottom: 1px solid #ccc;
    background: #f3f6f7;
  }
  table.type09 td {
    width: 350px;
    padding: 10px;
    vertical-align:center;
    border-bottom: 1px solid #ccc;
  }
  table.type10 {
    border-collapse: collapse;
    text-align: left;
    line-height: 1.5;
    width : 100%;
  }
  table.type10 thead th {
    padding: 11px;
    font-weight: bold;
    vertical-align: center;
    /* color: #369; */
    border-bottom: 2px solid rgb(141, 141, 141);
  }
  table.type10 body th {
    width: 350px;
    padding: 10px;
    font-weight: bold;
    vertical-align: top;
    border-bottom: 1px solid #ccc;
    background: #f3f6f7;
    
  }
  table.type10 td {
    width: 500px;
    padding: 10px;
    vertical-align:center;
    border-bottom: 1px solid #ccc;
    font-size: 18px;
  }
  
  table.type11 {
    border-collapse: collapse;
    text-align: left;
    line-height: 1.5;
    width : 100%;
  }
  table.type11 thead th {
    padding: 10px;
    font-weight: bold;
    vertical-align: center;
    /* color: #369; */
    border-bottom: 2px solid rgb(141, 141, 141);
  }
  table.type11 tbody th {
    max-width: 150px;
    padding: 10px;
    font-weight: bold;
    vertical-align: top;
    border-bottom: 1px solid #ccc;
    background: #f3f6f7;
  }
  table.type11 td {
    max-width: 350px;
    padding: 10px;
    vertical-align:center;
    border-bottom: 1px solid #ccc;
  }
  table.type11 td.img_area {
    max-width: 400px;
    padding: 10px;
    vertical-align:center;
    border-bottom: 1px solid #ccc;
  }


  table.type12 {
    border-collapse: collapse;
    text-align: left;
    line-height: 1.5;
    width: 100%;
    vertical-align: middle;
  }

  table.type12 thead th {
    padding: 10px;
    font-weight: bold;
    vertical-align: center;
    border-bottom: 1px solid #ccc; 
    border-top: 1px solid rgb(141, 141, 141);
    border-right: 1px solid #ccc; 
    border-left: 1px solid #ccc; 
    vertical-align: middle;
  }

  table.type12 tbody th {
    width: 150px;
    padding: 10px;
    font-weight: bold;
    vertical-align: top;
    border-bottom: 1px solid #ccc;
    background: #f3f6f7;
    border-right: 1px solid #ccc; /* 세로선 추가 */
    border-left: 1px solid #ccc; 
    vertical-align: middle;
  }

  table.type12 td {
    width: 350px;
    padding: 10px;
    vertical-align: center;
    border-bottom: 1px solid #ccc;
    border-right: 1px solid #ccc; /* 세로선 추가 */
    border-left: 1px solid #ccc; 
    vertical-align: middle;
  }

  .safe_4_rules {
    position : absolute;
    top : 0px;
    left : 0px;
    width : 100%;
  }

  .table_line_right {
    border-right: 1px solid #ccc;
  }

  .superscript {
    vertical-align: super;
    font-size: 12px;
  }

  .pledge_content {
    overflow:auto;
    @media screen and (min-width: 1065px) {
      width: 100%;
      height:calc(90vh - 155px);

      :deep(.v-card__text) {
        letter-spacing: .0125rem;
        font-size: 1.25rem;
        font-weight: 500;
      }

      :deep(.content_subtitle) {
        letter-spacing: .009375rem;
        font-size: 1rem;
        font-weight: 400;
        padding-left: 40px;
        padding-right: 40px;
      }
    }

    @media screen and (min-width: 600px) and (max-width: 1064px){
      height:calc(90vh - 135px);

      :deep(.v-card__text) {
        // background-color : blue;
        letter-spacing: .01rem;
        font-size: 1rem;
        font-weight: 500;
      }

      :deep(.content_subtitle) {
        // background-color : green;
        letter-spacing: .009375rem;
        font-size: 0.9rem;
        font-weight: 400;
        padding-left: 40px;
        padding-right: 40px;
      }
    }

    @media screen and (max-width: 601px) {
      height:calc(90vh - 115px);
      :deep(.v-card__text) {
        letter-spacing: .0075rem;
        font-size: 0.9rem;
        font-weight: 500;
      }

      :deep(.content_subtitle) {
        letter-spacing: .007rem;
        font-size: 0.8rem;
        font-weight: 400;
        padding-left: 20px;
        padding-right: 20px;
      }
    }
  }



</style>
